(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["thelone-product-offers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('thelone-offers')) {
    customElements.define('thelone-offers', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const scope = this.closest('product-component') || this.closest('.shopify-section');
        this.addEventListener('change', (event) => {
          const input = event.target;
          if (!input.matches('input[data-quantity]')) return;
          const form = scope.querySelector('product-form-component');
          const quantity = form?.querySelector('input[name="quantity"]');
          if (quantity) {
            quantity.value = input.dataset.quantity;
            quantity.dispatchEvent(new Event('change', { bubbles: true }));
          }
          const variantInput = form?.querySelector('input[name="id"]');
          if (!variantInput || variantInput.value === input.value) return;
          const picker = scope.querySelector('variant-picker');
          const url = new URL(this.dataset.productUrl, location.origin);
          url.searchParams.set('variant', input.value);
          url.searchParams.set('section_id', this.dataset.sectionId);
          if (picker?.fetchUpdatedSection) {
            picker.fetchUpdatedSection(url, { detail: { variantId: input.value } });
          } else {
            url.searchParams.delete('section_id');
            location.assign(url);
          }
        }, { signal: this.controller.signal });
        scope.addEventListener('change', (event) => {
          if (!event.target.matches('input[name="quantity"]')) return;
          const selected = this.querySelector('input:checked');
          if (selected && selected.dataset.quantity !== event.target.value) selected.checked = false;
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
